export default "/_next/static/images/investors-desktop-b196e7088cfbcaf98c0e3f860b93e0c5.png";